export class TimeTracker {
  private __start = TimeTracker.now();
  private __timer: number;

  constructor(private __waitUntil: number, protected _fn: (event: Event) => void) {}

  static now() {
    return new Date().getTime();
  }

  restart() {
    this.stop();
    this.start();
    return this;
  }

  start() {
    this.__start = TimeTracker.now();
    this.__timer = (setTimeout(() => {
      this.stop();
      this._fire();
    }, this.__waitUntil) as unknown) as number;

    return this;
  }

  reset(event: Event) {
    this.stop();
    this.start();
    this._fire(event);

    return this;
  }

  stop() {
    if (this.__timer > 0) {
      clearTimeout(this.__timer);
      this.__timer = 0;
    }

    return this;
  }

  protected _fire(event: Event = new CustomEvent('timed-out')) {
    const timeRunning = TimeTracker.now() - this.__start;
    if (timeRunning >= this.__waitUntil) {
      this._fn(event);
    }
  }
}
